import { expValEquals } from '@confluence/feature-experiments';

export type FollowingFeedNode = {
	content?: {
		contentProperties?: {
			latest?: {
				generatedBy?: string | null;
			} | null;
		} | null;
	} | null;
};

/**
 * A following-feed node is hidden only when it was generated by onboarding AND the
 * `cc-activation-use-generated-by-exp-gate` experiment is in the `test` cohort. Shared between
 * `Feed` (deciding whether the feed has any visible content) and `ActivityFeedCards` (filtering
 * the rendered list and pagination) so the predicate stays in one place.
 */
export const isVisibleFollowingFeedNode = (item?: FollowingFeedNode | null): boolean =>
	item?.content?.contentProperties?.latest?.generatedBy !== 'ONBOARDING' ||
	!expValEquals('cc-activation-use-generated-by-exp-gate', 'cohort', 'test');
